import { render, staticRenderFns } from "./SCardTaxComp.vue?vue&type=template&id=723d4b9a&"
import script from "./SCardTaxComp.vue?vue&type=script&lang=js&"
export * from "./SCardTaxComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports